import {GET_BALANCE, GET_BALANCE_REQUEST, GET_BALANCE_SUCCESS, GET_BALANCE_FAILUER } from "./types"



export const getBalance = (data) => ({
  type: GET_BALANCE,
  data,
});
export const getbalancerequest=()=>{
    return{
        type: GET_BALANCE_REQUEST
    }
}
export const getbalancesuccess=(cred)=>{
    return{
        type: GET_BALANCE_SUCCESS,
        payload: cred

    }
}

export const getbalancefailure=(error)=>{
    return{
        type: GET_BALANCE_FAILUER,
        payload: error

    }
}